export const MarkerTypes = {
  DRIVER: 'driver',
  WAREHOUSE: 'warehouse',
  APARTMENT: 'apartment',
  NORMAL: 'normal',
  OTHER: 'other'
}

export const MarkerIconPath = {
  DRIVER: './images/markers/car.png',
  WAREHOUSE: './images/markers/warehouse.png',
  DEFAULT: './images/markers/default.png'
}

export const ErrorTypes = {
  JSON: 0,
  HTML: 1
}

export const MapModes = {
  NONE: 'none',
  SELECT_START: 'select_start',
  SELECT_END: 'select_end'
}

export const FAULTY_PACKAGE_STATUS = {
  NEW_RECORD_STATUS: 1,
  CLIENT_REVIEWED: 2,
  UNI_CONFIRMED: 3
}

export const FAULTY_PACKAGE_RECORD_INFO = {
  id: '',
  record_status: '',
  warehouse: '',
  tracking_number: '',
  sender_reference: '',
  issue_type: '',
  package_status: '',
  item_number: '',
  image_count: '',
  verified_tracking_number: '',
  client_decision: '',
  client_file: '',
  action_taken: '',
  uni_notes: '',
  client_notes: '',
  closing_notes: '',
  updated_by: '',
  created_by: '',
  deleted_by: '',
  deleted_at: '',
  closed_at: '',
  updated_at: '',
  created_at: ''
}

// define the predefined role type
export const PREDEFINED_ROLE_TYPE = {
  super_admin: 'System Administrator'
}
